/* eslint-disable import/prefer-default-export */

export const sizeChoices = [{
  value: 'EXTRA_SMALL',
  label: 'XS',
}, {
  value: 'SMALL',
  label: 'S',
}, {
  value: 'MEDIUM',
  label: 'M',
}, {
  value: 'LARGE',
  label: 'L',
}, {
  value: 'EXTRA_LARGE',
  label: 'XL',
}];

export const sizeSimpleChoices = [{
  value: 'SMALL',
  label: 'S',
}, {
  value: 'MEDIUM',
  label: 'M',
}, {
  value: 'LARGE',
  label: 'L',
}];
